import { assertIsValidUrl, assertNumberBetween } from '../validators';
import { observable, runInAction } from './reactivity';
import { TimeInvariantBase } from './TimeInvariantBase';

const DEFAULT_SOURCE = '';
const DEFAULT_INTENSITY = 0;

export class ColorGradingSettings extends TimeInvariantBase {
    override _classType = 'ColorGradingSettings';
    override _name = 'ColorGradingSettings';

    @observable accessor #source = DEFAULT_SOURCE;
    @observable accessor #intensity = DEFAULT_INTENSITY;

    get intensity() {
        return this.#intensity;
    }

    set intensity(value: number) {
        if (this.intensity === value) {
            return;
        }
        assertNumberBetween(value, 0, 1);
        this.#intensity = value;
        this.requiresUpdate = true;
    }

    get source() {
        return this.#source;
    }

    set source(value: string) {
        if (this.source === value) {
            return;
        }

        if (value !== DEFAULT_SOURCE) {
            assertIsValidUrl(value);
        }
        this.#source = value;
        this.requiresUpdate = true;
    }

    override clear() {
        runInAction(() => {
            this.#source = DEFAULT_SOURCE;
            this.#intensity = DEFAULT_INTENSITY;
        });
    }

    override get editableProperties() {
        return ['source', 'intensity'];
    }
}
